import { Stack, StackProps } from '@chakra-ui/react'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import React from 'react'

export const ButtonStack: React.FC<{ children?: any; stackProps?: StackProps }> = props => {
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <Stack
      align={getBreakpointValue(['stretch', 'stretch', 'center'])}
      direction={getBreakpointValue(['column', 'column', 'row'])}
      gap={4}
      justify={getBreakpointValue(['stretch', 'stretch', 'center'])}
      {...props.stackProps}
    >
      {props.children}
    </Stack>
  )
}
